// removed by extract-text-webpack-plugin
module.exports = {"bhvfin":"CQO1SA9jUDW5ZTfiTKzlH","button":"_1mSaKFVHWmeGqaE-trcaHs","results":"_3yfIlWmqjGj7-FfsYvtwkF","compliance":"iDDsmaLwi8Ice8nDnTggk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App/App.css
// module id = 1160
// module chunks = 0